export default __webpack_public_path__ + "static/media/song_desc_icon.01785fa8.svg";